<template>
    <div class="p-3">
        <div>

            <div class="header-tracking">
                <AppLanguageSwitch style="position: absolute;top:10px;right: 10px;" />
                <h5 class="mt-2">{{ $t('trackOrderStatus') }}</h5>
                <h4 class="mt-3">{{ $t(orderCompletedMessage) }}</h4>
                <div>
                    <CButton class="btn-fade-theme">{{ tableName }}</CButton>
                    <CButton class="btn-fade-theme pt-2"><i class="fi fi-rr-refresh"></i> {{ $t('updatedAtQR') }} {{
                        lastUpdatedTime || '--:--:--' }}</CButton>
                </div>
            </div>
            <div v-if="loadingPage == true" style="margin-top: 150px;">
                <div class="status-filter-scroll mt-4 mb-3">
                    <div class="d-inline-flex">
                        <button v-for="status in statusFilters" :key="status.value" class="btn-filter"
                            :class="{ active: selectedStatus === status.value }" @click="selectedStatus = status.value">
                            {{ getOrderStatus(status.value) }}
                        </button>
                    </div>
                </div>
                <ul class="list-group list-group-flush mt-3" style="margin-bottom: 250px">
                    <li class="list-group-item pr-0 pl-0" v-for="(list, index) in filteredReceiptItems" :key="index">
                        <table style="width: 100%" aria-describedby="">
                            <tr>
                                <td style="width: 20%" valign="top" align="left">
                                    <div v-if="list.remoteImagePath === null ||
                                        list.remoteImagePath === undefined
                                    " :style="{
                                        'background-color': getImgColor(list.indexColor),
                                        'border-radius': '5px',
                                        width: '90px',
                                        height: '90px',
                                    }"></div>
                                    <div v-else :style="{
                                        'background-image': `url('${noImg}')`,
                                        'background-size': 'cover',
                                        'background-position': 'center center',
                                        'border-radius': '5px',
                                        width: '90px',
                                        height: '90px',
                                    }"><img class="image-inbox" :src="getImageURL(list.remoteImagePath, '100')"
                                            @error="setErrorImg($event, list.remoteImagePath)"></div>
                                </td>
                                <td class="pl-2" style="font-size: medium;" valign="top">
                                    <div class="d-flex justify-content-between">
                                        <div v-if="list.productPLU != undefined">
                                            <h6 class="font-weight-light">
                                                {{ getCartPLUName(list) }}
                                                <br />
                                            </h6>
                                            <!-- {{ list.productPLU.SKURatio }} {{ list.productPLU.unit.name || '' }}<br> -->
                                            <div v-if="list.orderedOptions !== undefined">
                                                <div v-if="list.orderedOptions.length > 0">
                                                    <div style="padding-bottom: 0px"
                                                        v-for="ordered in list.orderedOptions" :key="ordered.objectId"
                                                        class="p-0">
                                                        <small>
                                                            • {{ getOptionItemTranslation(ordered) }}
                                                        </small>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="list.note">
                                                <small class="text-description">
                                                    {{ $t('note') }} : {{ list.note }}
                                                </small>
                                            </div>
                                        </div>
                                        <div v-if="list.deleted_at == undefined">
                                            <span style="font-weight: lighter; font-size:small;padding: 1.5cap;"
                                                :class="getOrderStatusColor(list.status)">
                                                {{ getOrderStatus(list.status) }}
                                            </span>
                                        </div>
                                        <div v-else>
                                            <span style="font-weight: lighter; font-size:small;padding: 1.5cap;"
                                                :class="getOrderStatusColor('C')">
                                                {{ getOrderStatus('C') }}
                                            </span>
                                        </div>
                                    </div>
                                    <table style="width: 100%" aria-describedby="" class="mt-2">
                                        <tr>
                                            <td style="width: 50%">
                                                <h5 class="mb-0 font-weight-bold text-grey">
                                                    x{{ list.quantity }}
                                                    <span v-if="list.discountAmount && list.discountAmount > 0"
                                                        style="font-weight: lighter; font-size:small;padding: 1.5cap;background-color: var(--danger);"
                                                        class="badge text-white">
                                                        - {{ list.discountAmount.toFixed(2) }}
                                                    </span>
                                                </h5>
                                                <small class="text-description">
                                                    {{ $t('orderTime') }} :
                                                    {{ showCreatedAtTime(list.created_at) }}

                                                </small>
                                            </td>

                                            <td class="text-right">
                                                <h5 v-if="list.productSKU != undefined" class="mb-0">
                                                    ฿{{ SKUPrice(list.netAmount) }}
                                                </h5>
                                                <small class="text-white">-</small>
                                                <small class="text-description">{{ $t('orderedBy') }} {{ list.ordered_by
                                                    ||
                                                    list.created_by.username }}</small>
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                        </table>
                    </li>
                </ul>
                <div v-if="filteredReceiptItems.length === 0" class="text-center mt-5 text-muted">
                    <i class="fi fi-rr-box-open" style="font-size: 2rem;"></i>
                    <p class="mt-2">{{ $t('noOrderThisStatus') }}</p>
                </div>

            </div>
        </div>
        <div class="fixed-bottom p-2 w-100"
            style="padding: 20px; background-color: #ffffff;box-shadow: 0 -4px 8px rgba(0, 0, 0, 0.05);">
            <div class="row p-2  text-dark font-weight-bold">
                <div class="col font-weight-bold">
                    <h5> {{ itemCount }} {{ $t('item') }}
                        <span v-if="receiptDiscountAmount > 0"
                            style="font-weight: lighter; font-size:small;padding: 1.5cap;background-color: var(--danger);"
                            class="badge text-white">
                            - {{ receiptDiscountAmount.toFixed(2) }}
                        </span>
                    </h5>
                </div>
                <div class="col">
                    <h5 class="font-weight-bold text-right">
                        ฿{{ grandTotal }}
                    </h5>
                </div>
            </div>
            <CButton @click="refreshPage()" class="btn-color-theme" style="background-color: #29B46B;" block>{{
                $t('refresh') }}</CButton>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AppLanguageSwitch from '@/components/AppLanguageSwitch.vue'
import util from '@/util/util'
import axios from 'axios'
import poscrm from '@/services/poscrm'
import moment from 'moment'
import '@/util/menu.css'

export default {
    components: {
        AppLanguageSwitch
    },
    data() {
        return {
            receiptObjectId: '',
            receiptItems: [],
            receiptStatus: '',
            table: {},
            tableName: '',
            orderComplete: false,
            loading: false,
            loadingPage: null,
            paymentStatus: '',
            notificationModel: {
                color: '',
                title: '',
                text: '',
            },
            receiptGrandTotal: 0,
            receiptDiscountAmount: 0,
            selectedStatus: 'ALL',
            statusFilters: [
                { value: 'ALL', label: 'ทั้งหมด' },
                { value: 'N', label: 'ออเดอร์ใหม่' },
                { value: 'P', label: 'กำลังทำ' },
                { value: 'R', label: 'รอเสิร์ฟ' },
                { value: 'S', label: 'เสิร์ฟแล้ว' },
                // { value: 'A', label: 'เรียบร้อย' },
                { value: 'C', label: 'ยกเลิก' }
            ],
            lastUpdatedTime: null,


        }
    },
    computed: {
        ...mapGetters(['shopLineOA']),
        uid() {
            return `${localStorage.getItem('uid')}`
        },
        shopObjectId() {
            return `${localStorage.getItem('shopObjectId')}`
        },
        shop() {
            return this.shopLineOA.find(
                (detail) => detail.objectId === this.shopObjectId
            )
        },
        shopName() {
            if (this.shop) {
                return this.shop.shopName
            } else {
                return ''
            }
        },
        noImg() {
            return process.env.VUE_APP_NOIMAGE
        },
        itemCount() {
            if (this.receiptItems && this.receiptItems.length > 0) {
                return this.receiptItems.filter(
                    item => item.deleted_at === undefined && item.status !== 'C'
                ).length;
            }
            return 0;
        },
        grandTotal() {
            let total = 0
            if (this.receiptGrandTotal) {
                total = this.receiptGrandTotal
            } else {
                total = this.receiptItems.reduce((accum, product) => {
                    return accum + ((product.deleted_at == undefined) ? product.totalAmount : 0)
                }, 0)
            }
            return util.convertCurrency(total)
        },
        filteredReceiptItems() {
            if (this.selectedStatus === 'ALL') {
                return this.receiptItems
            }
            return this.receiptItems.filter(item => item.status === this.selectedStatus)
        },
        allDone() {
            return this.receiptItems.length > 0 && this.receiptItems.every(item =>
                item.status === 'S' || item.status === 'C' || item.deleted_at !== undefined
            )
        },
        orderCompletedMessage() {
            if (this.receiptItems.length === 0) return 'OnPreparingYourOrder'
            return this.allDone ? 'orderCompleteThanks' : 'OnPreparingYourOrder'
        },
    },
    created() {
        this.receiptObjectId = this.$route.params.objectId


        // ✅ ดึง token จาก query แล้วเก็บไว้ใน localStorage (ครั้งแรกที่เปิด)
        const tokenFromUrl = this.$route.query.token
        if (tokenFromUrl) {
            localStorage.setItem('token', tokenFromUrl)
        }

        // 👇 Check stored receipt first
        const cachedReceipt = JSON.parse(localStorage.getItem('latestReceipt'))
        if (cachedReceipt?.objectId === this.receiptObjectId) {
            const done = cachedReceipt?.receiptItems?.every(item =>
                item.status === 'S' || item.status === 'C' || item.deleted_at !== undefined
            )

            if (done) {
                console.log('[Info] Skipping API call — all items already done from cache.')
                this.receiptItems = cachedReceipt.receiptItems || []
                this.receiptStatus = cachedReceipt.receiptStatus
                this.receiptGrandTotal = cachedReceipt.grandTotal || 0
                this.receiptDiscountAmount = cachedReceipt.discountAmount || 0
                this.tableName = cachedReceipt.tableName || ''
                this.loadingPage = true
                this.lastUpdatedTime = moment().format('HH:mm:ss')
                return
            }
        }

        this.getReceiptTransaction()
        this.loading = false
        this.lastUpdatedTime = moment().format('HH:mm:ss')
    },
    methods: {
        ...util,
        getCartPLUName(list) {
            const locale = this.$i18n.locale
            const translation = list.nameTranslation || list.productPLU?.nameTranslation
            if (translation && translation[locale]) {
                return translation[locale]
            }
            return list.productPLU?.name || list.pluName || ''
        },
    getOptionItemTranslation(option) {
        const locale = this.$i18n.locale
        const translation = option.nameTranslation || option.optionItem?.nameTranslation
        if (translation && translation[locale]) {
            return translation[locale]
        }
        return option.optionItemName || ''
    },

        setErrorImg(event, image) {
            if (event.target.src == image) {
                event.target.src = this.noImg
            } else {
                event.target.src = image
            }
        },
        getOrderStatus(status) {
            switch (status) {
                case 'N':
                case 'ออเดอร์ใหม่':
                    return this.$i18n.t('newOrder')
                case 'P':
                case 'กำลังทำ':
                    return this.$i18n.t('OnPreparing')
                case 'C':
                case 'ยกเลิก':
                    return this.$i18n.t('cancel')
                case 'S':
                case 'เสิร์ฟแล้ว':
                    return this.$i18n.t('served')
                case 'R':
                case 'รอเสิร์ฟ':
                    return this.$i18n.t('waitForServe')
                case 'A':
                case 'เรียบร้อย':
                    return this.$i18n.t('OnSuccess')
                case 'ALL':
                    return this.$i18n.t('all')
                default:
                    return ''
            }
        },
        getOrderStatusColor(status) {
            switch (status) {
                case 'N':
                case 'ออเดอร์ใหม่':
                    return 'badge badge-info'
                case 'P':
                case 'กำลังทำ':
                    return 'badge badge-warning'
                case 'C':
                case 'ยกเลิก':
                    return 'badge badge-danger'
                case 'S':
                case 'เสิร์ฟแล้ว':
                    return 'badge badge-served'
                case 'R':
                case 'รอเสิร์ฟ':
                    return 'badge badge-wait-serve '
                case 'A':
                case 'เรียบร้อย':
                    return 'badge badge-success'
                default:
                    return ''
            }
        },
        showCreatedAtTime(time) {
            if (time) {
                return moment(time).format('HH:mm')
            } else {
                return ''
            }
        },
        getImgColor(indexColor) {
            return util.generateColor(indexColor)
        },
        SKUPrice(price) {
            return util.convertCurrency(Number(price))
        },
        convertCurrency(num) {
            if (typeof num == 'number') {
                return '(+' + util.convertCurrency(Number(num)) + ')'
            } else {
                return ''
            }
        },
        async getReceiptTransaction() {
            try {
                const BaseURL =  process.env.VUE_APP_API_URL
                const res = await axios({
                    method: 'get',
                    baseURL: BaseURL,
                    url: `/api/v1.0/selforder/receipt/${this.receiptObjectId}`,
                    headers: {
                        authorization: localStorage.getItem('token')
                    }
                });

                const receipt = res.data?.data || null;
                if (!receipt) {
                    this.loadingPage = false;
                    return;
                }

                this.receiptItems = receipt.receiptItems || [];
                this.receiptStatus = receipt.receiptStatus;
                this.receiptObjectId = receipt.objectId;
                this.receiptGrandTotal = receipt.grandTotal || 0;
                this.receiptDiscountAmount = receipt.discountAmount || 0;
                this.tableName = receipt.tableName || '';
                this.loadingPage = true;

                localStorage.setItem('latestReceipt', JSON.stringify(receipt)); // ✅ Save it here

                if (this.receiptItems.length < 1) {
                    this.loadingPage = false;
                }
            } catch (error) {
                if (error.response?.data?.error?.status === 429) {
                    console.warn('[Rate Limit] Fallback to localStorage receipt.');

                    const cachedReceipt = JSON.parse(localStorage.getItem('latestReceipt'));
                    if (cachedReceipt?.objectId === this.receiptObjectId) {
                        this.setReceiptFromData(cachedReceipt);
                        return;
                    } else {
                        console.error('No cached receipt found for fallback.');
                    }
                } else {
                    console.error('Error fetching receipt:', error);
                }
                this.loadingPage = false;
            }
        },
        setReceiptFromData(receipt) {
            this.receiptItems = receipt.receiptItems || [];
            this.receiptStatus = receipt.receiptStatus;
            this.receiptObjectId = receipt.objectId;
            this.receiptGrandTotal = receipt.grandTotal || 0;
            this.receiptDiscountAmount = receipt.discountAmount || 0;
            this.tableName = receipt.tableName || '';
            this.loadingPage = true;
            this.lastUpdatedTime = moment().format('HH:mm:ss');
        },

        refreshPage() {
            window.location.reload()
        },

    },
}
</script>
<style scoped>
img.image-inbox {
    position: relative;
    object-fit: cover;
}

.header-tracking {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    background: linear-gradient(135deg, #29B46B, #1D9F5F, #0F8E4A);

    text-align: center;
    padding: 3cap;
    color: white;
}


.btn-fade-theme {
    background-color: #42ca82;
    color: white;
    margin: 1cap;
}

.status-filter-scroll {
    overflow-x: auto;
    white-space: nowrap;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    /* Firefox */
    -ms-overflow-style: none;
    /* Internet Explorer / Edge */
}

.status-filter-scroll::-webkit-scrollbar {
    display: none;
    /* Chrome, Safari */
}


.btn-filter {
    background-color: #ffffff;
    color: #29B46B;
    border: 1px solid #29B46B;
    border-radius: 999px;
    /* pill style */
    padding: 6px 16px;
    font-size: 0.9rem;
    margin-right: 8px;
    transition: all 0.2s ease-in-out;
    white-space: nowrap;
}

.btn-filter:hover {
    background-color: #29B46B;
    color: #ffffff;
    box-shadow: 0 2px 8px rgba(41, 180, 107, 0.3);
}

.btn-filter.active {
    background-color: #29B46B;
    color: white;
    font-weight: 500;
    border: 1px solid transparent;
}

.btn-filter:focus {
    outline: none;

}
</style>